import { render, staticRenderFns } from "./ReportGenerator.vue?vue&type=template&id=2542fd59&scoped=true&"
import script from "./ReportGenerator.vue?vue&type=script&lang=ts&"
export * from "./ReportGenerator.vue?vue&type=script&lang=ts&"
import style0 from "./ReportGenerator.vue?vue&type=style&index=0&id=2542fd59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542fd59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
